import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const MangementWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

export const ManagementWidgetsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  gap: "40px",
  marginBottom: "24px",
}));

export const ManagementWidgetsItemContainer = styled("div")(() => ({
  border: "1px solid",
  borderColor: colors.gray200,
  borderRadius: "12px",

  backgroundColor: colors.gray50,
  width: "256px",
  height: "91px",
  padding: "16px 20px 16px 20px",
  gap: "4px",
  opacity: "0px",

  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  position: "relative",
}));

export const ManagementWidgetsItemTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: "15px",
  letterSpacing: "0.5px",
  textAlign: "center",
  textUnderlinePosition: "from-font",
  textDecorationSkipInk: "none",
}));

export const ManagementWidgetsItemValue = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "32px",
  fontWeight: 700,
  lineHeight: "40px",
  textUnderlinePosition: "from-font",
  textDecorationSkipInk: "none",
  color: colors.blue500,
}));

export const ManagementWidgetsItemIconContainer = styled("div")(() => ({
  position: "absolute",
  top: 0,
  right: 0,
  transform: "rotate(-20deg)",
}));
